import { render, staticRenderFns } from "./InvoiceRendererV2.vue?vue&type=template&id=743ee9fe&scoped=true&"
import script from "./InvoiceRendererV2.vue?vue&type=script&lang=js&"
export * from "./InvoiceRendererV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743ee9fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
